// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ko-0";
export var fileList = "_ko-2";
export var removeFileButton = "_ko-1";